module.exports = __webpack_public_path__ + "static/media/0_2018_09_23.2c306685.jpg";